import { ActionButtonVariants } from 'components/action-button';

export const config = {
  buttonVariant: ActionButtonVariants.OUTLINE,
  hasStartIcon: true,
  showNumItems: true,
  isSquare: false,
};
